import api from './api';
import { config } from '../config/env';

class BillingService {
    async getPlans() {
        const response = await api.get(`/subscriptions/plans`);
        return response.data;
    }

    async createCheckout(planId, billingCycle = 'monthly', couponCode = null) {
        const response = await api.post(`/subscriptions/checkout`, { planId, billingCycle, couponCode });
        return response.data;
    }

    async validateCoupon(code, planId) {
        const response = await api.get(`/subscriptions/validate-coupon?code=${code}&planId=${planId}`);
        return response.data;
    }

    async cancelSubscription() {
        const response = await api.post(`/subscriptions/cancel`, {});
        return response.data;
    }

    async getHistory(page = 1, limit = 12) {
        const response = await api.get(`/subscriptions/history?page=${page}&limit=${limit}`);
        return response.data;
    }

    async contactEnterprise(data) {
        const response = await api.post(`/subscriptions/contact-enterprise`, data);
        return response.data;
    }

    initializePaddle(paddlePublicKey, eventCallback) {
        if (window.Paddle) {
            return;
        }

        const script = document.createElement('script');
        script.src = 'https://cdn.paddle.com/paddle/v2/paddle.js';
        script.async = true;
        script.onload = () => {
            if (paddlePublicKey) {
                if (config.PADDLE_ENVIRONMENT) {
                    window.Paddle.Environment.set(config.PADDLE_ENVIRONMENT);
                }
                window.Paddle.Initialize({
                    token: paddlePublicKey,
                    eventCallback: eventCallback
                })
            }
        };
        document.body.appendChild(script);
    }

    openCheckout(transactionId, checkoutUrl) {
        if (window.Paddle) {
            window.Paddle.Checkout.open({
                transactionId: transactionId
            });
        } else {
            window.location.href = checkoutUrl;
        }
    }
}

export default new BillingService();
